module.exports = __webpack_public_path__ + "static/airport-video-cover-db36bcd19585ab60caee1598771eb238.jpg";